import Remove from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import Button from "../Button/Button";
import { FieldType } from "../../../services/helpers/types";
import { useTranslation } from "react-i18next";

interface ButtonFieldProps {
  field: FieldType;
  value?: string;
  onChange?: (value: string) => void;
}

const ButtonField = (props: ButtonFieldProps) => {
  const { value, field, onChange } = props;

  const { t } = useTranslation();

  const handleClick = () => {
    if (onChange) {
      if (value === field.defaultValue) {
        onChange("");
      } else {
        onChange(field.defaultValue);
      }
    }
  };

  const getButtonIcon = () => {
    if (value === field.defaultValue) {
      return <Remove />;
    } else {
      return <AddIcon />;
    }
  };

  return (
    <div className="dui-button-field">
      <div className="dui-button-field-content">{field.defaultValue}</div>
      <div className="dui-button-field-actions">
        <Button
          icon={getButtonIcon()}
          type="secondary"
          onClick={handleClick}
          className="dui-button-field-button"
        >
          {value === field.defaultValue ? t("remove") : t("add")}
        </Button>
      </div>
    </div>
  );
};

export default ButtonField;
